import { writable } from 'svelte/store'
import { getFxRates } from '../api/api.js'

function makeRatePollStore () {
  let timer
  const { subscribe, set, update } = writable({})

  const fetcher = () => {
    fetch(`https://blockchain.info/ticker?t=${Date.now()}`).then(async response => {
      const rates = {}
      const fallbackRates = await getFxRates()
      const liveRates = await response.json()
      if (fallbackRates && fallbackRates.USD && liveRates && liveRates.USD) {
        const fallbackUSDFactor = fallbackRates.USD / liveRates.USD.last
        // For currencies with live rates from blockchain.info, use those rates directly
        Object.keys(fallbackRates).forEach(currency => {
          if (currency === 'BTC') {
            rates.BTC = 1
          } else if (liveRates[currency]) {
            rates[currency] = liveRates[currency].last
          } else {
            // For other currencies, estimate the current rate from the live USD/BTC pair
            rates[currency] = fallbackRates[currency] / fallbackUSDFactor
          }
        })
      }
      set(rates)
    }).catch(err => {
      if (config.dev) console.log('error fetching exchange rates: ', err)
    })
  }
  const init = async () => {
    const fallbackRates = await getFxRates()
    set(fallbackRates)
  }
  init()
  fetcher()
  timer = setInterval(fetcher, 120000)

  return {
    subscribe,
    set,
    update
  }
}

export const liveFxRates = makeRatePollStore()
